import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

const MAPS_QUERY = "Palmisano Family Dentistry, 2020 Dickory Ave Suite 104, River Ridge, LA 70123";
const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`;
const MAPS_EMBED = `https://maps.google.com/maps?q=${encodeURIComponent(MAPS_QUERY)}&z=15&output=embed`;

export default function Footer() {
  return (
    <footer id="contact" className="relative z-10 bg-[#2A2E26] text-[#F9F6F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="font-display text-4xl tracking-tight mb-6">
            Palmisano<span className="text-[#C05C42]">.</span>
          </div>
          <p className="text-[#C9D1C5] max-w-sm leading-relaxed mb-8">
            Warm, family-owned dentistry for River Ridge and the greater New Orleans area —
            gentle care for every smile.
          </p>
          <a href="tel:5047330871" data-testid="footer-call-btn"
            className="btn-terra font-semibold px-6 py-3.5 rounded-full inline-flex items-center gap-2">
            <Phone size={16} /> Call 504-733-0871
          </a>
        </div>

        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#A8B5A2] mb-5">Visit &amp; Contact</p>
          <ul className="space-y-4 text-[#F0EBE1]">
            <li>
              <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-address-link"
                className="flex items-start gap-3 hover:text-[#C05C42] transition-colors">
                <MapPin size={18} className="text-[#C05C42] mt-0.5 shrink-0" />
                <span>2020 Dickory Ave., Suite 104 · River Ridge, LA 70123</span>
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="text-[#C05C42] mt-0.5 shrink-0" />
              <span>
                <a href="tel:5047330871" className="hover:text-[#C05C42] transition-colors">504-733-0871</a>
                {" · "}
                <a href="tel:5047340098" className="hover:text-[#C05C42] transition-colors">504-734-0098</a>
              </span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-[#C05C42] shrink-0" />
              <a href="mailto:palmisanodental@gmail.com" data-testid="footer-email-link" className="hover:text-[#C05C42] transition-colors">
                palmisanodental@gmail.com
              </a>
            </li>
          </ul>

          <p className="text-xs uppercase tracking-[0.2em] text-[#A8B5A2] mt-10 mb-5">Hours</p>
          <ul className="space-y-2 text-[#F0EBE1] text-sm">
            <li className="flex justify-between max-w-xs"><span>Monday</span><span className="text-[#C9D1C5]">9:00am – 5:00pm</span></li>
            <li className="flex justify-between max-w-xs"><span>Tuesday</span><span className="text-[#C9D1C5]">8:00am – 5:00pm</span></li>
            <li className="flex justify-between max-w-xs"><span>Wednesday</span><span className="text-[#C9D1C5]">8:00am – 5:00pm</span></li>
            <li className="flex justify-between max-w-xs"><span>Thursday</span><span className="text-[#C9D1C5]">8:00am – 5:00pm</span></li>
            <li className="flex justify-between max-w-xs"><span>Friday</span><span className="text-[#C9D1C5]">By appointment</span></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#A8B5A2] mb-5">Find us</p>
          <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-map-link"
            className="group block relative rounded-3xl overflow-hidden border border-[#F9F6F0]/10">
            <iframe
              title="Palmisano Family Dentistry location"
              src={MAPS_EMBED}
              className="w-full h-56 grayscale-[0.2] pointer-events-none"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <span className="absolute bottom-3 left-3 right-3 backdrop-blur-md bg-[#2A2E26]/80 text-[#F9F6F0] text-sm font-semibold rounded-xl px-4 py-3 flex items-center justify-between">
              <span className="flex items-center gap-2"><MapPin size={16} className="text-[#C05C42]" /> Open in Google Maps</span>
              <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </span>
          </a>
          <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-directions-link"
            className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#C05C42] hover:text-[#F9F6F0] transition-colors">
            Get directions <ArrowUpRight size={15} />
          </a>
        </div>
      </div>

      <div className="border-t border-[#F9F6F0]/10 py-6 text-center text-sm text-[#A8B5A2]">
        © {new Date().getFullYear()} Palmisano Family Dentistry · River Ridge, LA
      </div>
    </footer>
  );
}
